import styles from './Loader.module.css';

export default function Loader(props) {
  return (
    <div className={styles.loaderWrapper + ' ' + styles[props.size] + ' ' + props.className} style={props.style}>
      <div className={styles.loader}></div>
      {props.tip && <div data-testid='loadermsg' className={styles.mt8}>{props.tip}</div>}
    </div>
  )
}